function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext } from 'react';
import { ThemeContext, ThemeProvider } from 'styled-components';
import { useThemePreferenceContext } from './ThemePreferenceContext';
import * as themeObjects from './themes';
export function StashUIThemeProvider(props) {
  var preferences = useThemePreferenceContext();
  var mode = props.mode || (preferences === null || preferences === void 0 ? void 0 : preferences.mode) || 'light';
  var theme = props.theme || (preferences === null || preferences === void 0 ? void 0 : preferences.theme) || 'rise';

  var themeObject = _objectSpread(_objectSpread({
    mode: mode,
    theme: theme
  }, themeObjects[theme]), {}, {
    colors: themeObjects[theme].colors[mode],
    shadows: themeObjects[theme].shadows[mode]
  });

  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeObject
  }, props.children);
}
export var useTheme = function useTheme() {
  return useContext(ThemeContext);
};
export default StashUIThemeProvider;